import client from '../client'

const PATH = '/matching-items-data'

/**
 * Get a page of MatchingItems with their data.
 * See the matching-api endpoint docs for more info.
 * 
 * @param {Object} params
 * @param {Number[]} avoidFeatureId the QMasterFeatureIds to filter the items that already
 *  have tagged features with those ids.
 * @param {Number} classificationId the id of the classification to filter the items
 * @param {Number} [page=1] the page to get
 */
function get({ avoidFeatureIds, classificationId, page = 1 }) {
  return client.get(PATH, { params: { avoidFeatureIds, classificationId, page } }).then(({ data }) => data)
}

export default {
  get
}